import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePASAdminAuth } from '../context/PASAdminAuthContext';

const PUBLIC_EXACT = ['/', '/pas', '/pas/login', '/pas/signup', '/pas/dashboard', '/pas/banking', '/pas/swap', '/pas/pos', '/pas/desk', '/pas/bank',
  '/pas/purchase/success', '/pas/subscription/success', '/pas/eth/success', '/pas/gas/success', '/pas/admin/login', '/pas/admin/dashboard',
  '/terms', '/privacy', '/compliance', '/reserves', '/pas/tax-forms', '/pas/credit-agreement', '/pas/exchange-agreements'];
const PUBLIC_PREFIX = ['/pas/checks/', '/verify-check/', '/verify-statement/', '/pas/tax-forms/', '/pas/treasury-check/', '/verify-treasury-check/', '/claim-treasury-check/'];

export const isPublicPath = (path) => {
  const p = path.length > 1 ? path.replace(/\/+$/, '') : path;
  return PUBLIC_EXACT.includes(p) || PUBLIC_PREFIX.some(prefix => p.startsWith(prefix));
};

export const SiteGate = ({ children }) => {
  const location = useLocation();
  const { pasAdmin, loading } = usePASAdminAuth();
  if (isPublicPath(location.pathname)) return children;
  if (loading) return <div className="min-h-screen bg-slate-900" data-testid="site-gate-loading" />;
  if (!pasAdmin) return <Navigate to="/pas/admin/login" replace state={{ from: location.pathname + location.search, restricted: true }} />;
  return children;
};
